function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5893 14.4127L11.2367 10.06C13.3063 7.33945 12.7786 3.45627 10.058 1.38666C7.33745 -0.682932 3.45427 -0.155226 1.38466 2.56533C-0.684931 5.28588 -0.157224 9.16906 2.56333 11.2387C4.7776 12.9231 7.84371 12.9231 10.058 11.2387L14.4107 15.5913C14.7385 15.9111 15.2615 15.9111 15.5893 15.5913C15.9145 15.2657 15.9145 14.7383 15.5893 14.4127ZM1.83333 6.33333V6.33333C1.83333 3.84805 3.84805 1.83333 6.33333 1.83333C8.81861 1.83333 10.8333 3.84805 10.8333 6.33333C10.8333 8.81861 8.81861 10.8333 6.33333 10.8333C3.84927 10.8304 1.83627 8.81739 1.83333 6.33333L1.83333 6.33333Z",
  fill: "#4F4F4F"
});

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.a862b0bb.svg";
export { ForwardRef as ReactComponent };